import { styled } from "@mui/material/styles";
const ListWrapper = styled("div")`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
`;
export {
  ListWrapper
};
